import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, action } from 'mobx'
import { i18nTranslate } from 'src/utils'
import { LearnMoreSubscriptionModal } from 'src/views/components/SubscriptionComponents'
import { TickIcon } from 'src/views/components/Icons/TickIcon'

@observer
class BundleSubscribeBenefits extends Component {
  @observable showLearnMoreSubsModal = false

  @action
  toggleLearnMoreSubsModal = () => {
    this.showLearnMoreSubsModal = !this.showLearnMoreSubsModal
  }

  render() {
    const benefits = [
      i18nTranslate(
        'subscriptions.benefit_loyalty_rewards',
        'Earn loyalty rewards',
        {
          nameSpace: 'ssr-resource',
        }
      ),
      i18nTranslate(
        'subscriptions.benefit_free_shipping',
        'Enjoy free shipping & returns',
        {
          nameSpace: 'ssr-resource',
        }
      ),
    ]

    const handleLearnMoreKeyDown = e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        this.toggleLearnMoreSubsModal()
      }
    }

    return (
      <div
        className="bundle-subscribe-benefits-card"
        data-testid="qa-unified-subscribe-benefits"
        role="region"
        aria-labelledby="benefits-title">
        <p
          className="bundle-subscribe-benefits-title"
          id="benefits-title"
          tabIndex={0}>
          {i18nTranslate(
            'subscriptions.benefits_of_subscribing',
            'Benefits of Subscribing',
            { nameSpace: 'ssr-resource' }
          ) + ':'}
        </p>
        <ul
          className="bundle-subscribe-benefits-list"
          tabIndex={0}
          aria-describedby="qa-benefits-announcement">
          {benefits.map((benefit, index) => (
            <li key={index} className="bundle-subscribe-benefits-item">
              <span
                className="bundle-subscribe-benefits-icon"
                aria-hidden="true">
                <TickIcon width="12" height="12" fillColor="#ffffff" />
              </span>
              {benefit}
            </li>
          ))}
        </ul>
        <div
          id="qa-benefits-announcement"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          className="sr-only"
          data-testid="qa-benefits-announcement">
          {benefits.join(', ')}
        </div>
        <button
          className="bundle-subscribe-learn-more"
          type="button"
          data-testid="qa-pdp-learn-more-text"
          onClick={this.toggleLearnMoreSubsModal}
          onKeyDown={handleLearnMoreKeyDown}
          aria-label={i18nTranslate(
            'subscriptions.learnMore_aria_label',
            'Learn more about subscription benefits',
            { nameSpace: 'ssr-resource' }
          )}
          aria-expanded={this.showLearnMoreSubsModal}>
          {i18nTranslate('pdp.paypallink', 'Learn More')}
        </button>
        <LearnMoreSubscriptionModal
          show={this.showLearnMoreSubsModal}
          onHide={this.toggleLearnMoreSubsModal}
        />
      </div>
    )
  }
}

export { BundleSubscribeBenefits }
export default BundleSubscribeBenefits
